import Header from '../components/Header';
import GoogleHealthTokenUpdater from '../components/GoogleHealthTokenUpdater';


export function ToolGoogleHealthTokenUpdater() {


  return (
    <div className="mainAppContainer">
      <div className='pageContainer'>
        <Header long={true} />
        <GoogleHealthTokenUpdater />
      </div>
    </div>
  );
}

export default ToolGoogleHealthTokenUpdater
